import useGetCompletedOnboardingItems from './useGetCompletedOnboardingItems';

export default useGetCompletedOnboardingItems;
export * from './useGetCompletedOnboardingItems';
